import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Toggle } from 'material-ui';
import { saveSettings } from '../__store__/actions';

const ContractSettings = (props) => {
  const { contractingReminders, loading, saveSettings: saveChange } = props;
  const contractReminders = contractingReminders.map(e => ({
    ...e,
    locked: false,
    text: `${e.days} days ${e.priorAfter} ${e.fromDate === 'deadline' ? 'to deadline' : 'the request was sent'}`,
  }));
  return (
    <div>
      <div style={{
        paddingBottom: '12px',
        borderBottom: '1px solid #e6e9ec',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      >
        <div style={{ fontSize: '24px', fontWeight: 400 }}>Contract Settings</div>
        <div style={{ display: 'flex', alignItems: 'center' }} />
      </div>
      Automated Contract Request Reminders (only sent if rates are not marked as received)
      <div style={{
        marginTop: '20px',
      }}
      >
        {contractReminders.map(({
          locked,
          enabled,
          text,
        }, ix) => (
          <div
            style={{
              borderBottom: '1px solid #e6e9ec',
              padding: '10px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
            key={ix}
          >
            <div style={locked ? { color: 'rgba(0, 0, 0, 0.24)' } : {}}>{text}</div>
            <div
              className="hint--top"
              aria-label={(() => {
                if (locked) return 'These reminder are always sent';
                return enabled ? 'Turn off email reminder' : 'Turn on email reminder';
              })()}
              style={{ ...(loading ? { opacity: '0.3' } : {}) }}
            >
              <Toggle
                toggled={enabled}
                thumbStyle={enabled ? {} : { backgroundColor: '#ffcccc' }}
                trackStyle={enabled ? {} : { backgroundColor: '#ff9d9d' }}
                {...locked || loading ? { disabled: true } : {}}
                onToggle={() => {
                  saveChange({
                    companySettings: {
                      contractingReminders: contractingReminders.map((e, iy) => {
                        if (ix !== iy) return e;
                        return {
                          ...e,
                          enabled: !enabled,
                        };
                      }),
                    },
                  });
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
ContractSettings.defaultProps = {
  contractingReminders: [],
  loading: true,
  loaded: false,
  saveSettings: () => {},
};

ContractSettings.propTypes = {
  contractingReminders: propTypes.array,
  loading: propTypes.bool,
  loaded: propTypes.bool,
  saveSettings: propTypes.func,
};

const select = ({
  settingsReducer: {
    companySettings: { contractingReminders }, loading, loaded,
  },
}) => ({
  contractingReminders,
  loading,
  loaded,
});

export default connect(select, {
  saveSettings,
})(ContractSettings);



// WEBPACK FOOTER //
// ./src/app/components/settings/companySettings/contract-settings.jsx